import { createSelector } from 'reselect'

const getInteractiveVideoData = state => state.interactiveVideoCreation
const getAssets = state => state.assets

export default createSelector(
	[ getInteractiveVideoData, getAssets ],
	( interactiveVideo, assets ) => {
		const posterId = interactiveVideo.media.posterUid
		const imageSizes =
			(assets.images[posterId] && assets.images[posterId].sizes)
				? assets.images[posterId].sizes : {}

		const image = imageSizes.small || imageSizes.medium

		return {
			thumbnail: image ? image.path : null,
		}
	}
)
